import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// Igual que MTText: 13 px y el peso heredado de la celda (400 normal, 600 en las no leídas)
export const MTDateStyled = styled.div`
  font-size: 13px;
  font-weight: inherit;
  text-align: start;
  color: ${tokens.color.text.primary};
`
